<template>
    <!--
        Shared inline field messaging. One slot below a form field renders, in
        priority: an active error (with a leading glyph), or a persistent hint
        when there is no error. Extracted so PretorInput / PretorDropdown /
        PretorDatePicker / PretorTextArea share one copy of the markup, styles
        and swap motion instead of each carrying its own.
    -->
    <transition name="pretorField-msg" mode="out-in">
        <p v-if="message" key="error" class="pretorField__error">
            <i class="bi bi-exclamation-circle-fill"></i>
            <span>{{ message }}</span>
        </p>
        <p v-else-if="hint" key="hint" class="pretorField__hint">{{ hint }}</p>
    </transition>
</template>

<script>
export default {
    name: 'PretorFieldError',
    props: {
        // The active error message; empty string renders nothing.
        message: {
            type: String,
            required: false,
            default: ''
        },
        // Optional persistent helper text shown when there is no error.
        hint: {
            type: String,
            required: false,
            default: ''
        }
    }
}
</script>

<style scoped>
/* Persistent helper text — quiet, sits under the field */
.pretorField__hint {
    margin: 6px 2px 0;
    font-size: 12px;
    line-height: 1.45;
    color: #857f94;
}

/* Inline error — names the problem, with a leading glyph */
.pretorField__error {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    margin: 6px 2px 0;
    font-size: 12px;
    line-height: 1.45;
    color: #c0392b;
}

.pretorField__error i {
    flex-shrink: 0;
    margin-top: 1px;
    font-size: 12px;
}

/* Message swap: settle in under the field, leave without fuss */
.pretorField-msg-enter-active {
    transition: opacity 200ms cubic-bezier(0.23, 1, 0.32, 1), transform 200ms cubic-bezier(0.23, 1, 0.32, 1);
}

.pretorField-msg-leave-active {
    transition: opacity 120ms ease;
}

.pretorField-msg-enter-from {
    opacity: 0;
    transform: translateY(-3px);
}

.pretorField-msg-leave-to {
    opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
    .pretorField-msg-enter-active,
    .pretorField-msg-leave-active {
        transition: opacity 120ms ease;
    }

    .pretorField-msg-enter-from {
        transform: none;
    }
}
</style>
